/**
 * Clean PPLX internal links from text.
 * - Action links ([text](pplx://action/*)): Preserves text content
 * - All other pplx:// links: Removes entirely
 * Keep in sync with pplx/common/core/string/utils.py clean_pplx_action_links
 */
export const cleanPPLXActionLinks = (text) => {
    const nonPPLXActionPattern = /\s?\[([^\]]+)\]\(pplx:\/\/(?!action\/)[^)]+\)/g;
    const cleaned = text.replace(nonPPLXActionPattern, '');
    const pplxActionPattern = /\[([^\]]+)\]\(pplx:\/\/action\/[^)]+\)/g;
    return cleaned.replace(pplxActionPattern, '$1');
};
//# sourceMappingURL=cleanPPLXActionLinks.js.map